import { useMedicationConfigOverride } from '../contexts/DrugProgramProvider';
import type {
    AuthorizedMedicationInfoFragment,
    UnknownMedicationInfoFragment,
} from '../graphql/generated/graphql';

import { useDrugKey } from './use-drug-key';

export const useDrugName = (
    medication: AuthorizedMedicationInfoFragment | UnknownMedicationInfoFragment
) => {
    const drugKey = useDrugKey(medication);
    const medConfig = useMedicationConfigOverride();

    return drugKey ? medConfig.drugNames[drugKey] : '';
};
